import { Tool, ToolMenu, DEBUG_MENU_ID } from './ToolMenu';
import { DebugLogin } from './starts/login.debug';
import { DebugSelectPlan } from './starts/getPlan.debug';
import { DebugSession } from './starts/DebugSession';

// 2D ヘッダーの「ファイル」メニュー（index.html）の直後に置く。無ければ「選択」メニューの直後
const ANCHOR_MENU_IDS = ['headerMenuFile', 'headerMenuSelect'];
const MENU_TAG = 'li';
const DEBUG_MENU_CLASS = 'headerDropdownTrigger js-notForMobile';
const DEBUG_MENU_HTML = '<button><span class="icon icon-file"></span><span class="iconName"><span class="jp">デバッグ</span><span class="en">Debug</span></span></button>'
  + '<div class="headerDropdownList"><ul></ul></div>';

export class BuildDebugMenu {
  // この関数でテスト用のToolをセットしてください
  public setTools(): void {
    // 今あるツールは localhost 専用。デプロイ環境の debug_mode では空メニューを出さない
    if (!DebugSession.isEnabled()) return;
    // pageshow で onLoad が再実行されても二重に追加しない
    if (document.getElementById(DEBUG_MENU_ID)) return;
    if (!this.createMenuRoot()) return;
    this.create(DebugLogin);
    this.create(DebugSelectPlan);
  }

  /** ヘッダーに「デバッグ」メニューを作る。挿入先が無ければ false */
  private createMenuRoot(): boolean {
    const anchor = ANCHOR_MENU_IDS.map((id) => document.getElementById(id)).find((el) => el);
    if (!anchor) return false;

    const menu = document.createElement(MENU_TAG);
    menu.id = DEBUG_MENU_ID;
    menu.className = DEBUG_MENU_CLASS;
    menu.innerHTML = DEBUG_MENU_HTML;
    anchor.parentNode.insertBefore(menu, anchor.nextSibling);
    return true;
  }

  private create<T extends Tool>(ServiceClass: new () => T): this {
    new ToolMenu(new ServiceClass());
    return this;
  }
}
